import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const montserratFontFamily = "family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900";

const fontFamilies = [montserratFontFamily];

const setPostStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPostStyleGuideTheme({
        breakpoints: {
            //       xs,  sm,  md,  lg,   xl
            values: [240, 425, 768, 1024, 1200],
            maxWidths: [540, 1200, 1200, 1200, 1200],
        },
        typography: {
            fontFamilyImportUrl: `https://fonts.googleapis.com/css2?${fontFamilies.join("&")}&display=swap`,
            // 300: Light
            // 400: Regular
            // 500: Medium
            // 600: Semibold
            // 700: Bold
            // 800: ExtraBold
        },
    });
};

export default setPostStyles;
